import { CrewMember } from '@bechtel/types';

export interface StencilSelectorProps {
  loading: boolean;
  items: CrewMember[];
  fieldName: string;
  onSelectedItemsChange?: (selectedItems: any) => void;
  onSearch?: (query: string) => void;
  hideDropDownIcon?: boolean;
  formLabel?: string;
  placeholder?: string;
  enableClientSearch?: boolean;
}
